export default {
  platformTitle: '晨昏线机器人异构多机集群作业管理平台',
  platformTitleFull: '晨昏线机器人异构多机集群作业管理平台',
  homeScreen: '首页大屏',
  hcScreen: '零售管理',
  uavCenter: '无人机管控中心',
  robotDogCenter: '机器狗管控中心',
  robotCenter: '机器人管控中心',
  businessCenter: '业务中心',
  robotCenterOverall: '整体管控',
  robotCenterSmt: '智能仓储',
  smtJobOverview: '作业总览',
  smtJobOverviewDesc: '任务、设备与异常的实时汇总',
  smtDispatch: '模拟派单',
  smtDispatchDesc: '选择业务流程后配置工位与设备；一个拣选工位对应一个播种架（36 个播种框），架上可同时承接多个订单',
  smtTaskList: '任务列表',
  smtTaskListDesc: '一个任务包含拣选与复核两个步骤，默认按任务维度展示全部订单',
  smtStationList: '工位列表',
  smtStationListDesc: '拣选工位与复核工位数量一致，按任务流程类型分配给相应工位；一个工位对应一个播种架（4 行 × 9 列 ＝ 36 个播种框）',
  smtDevice: '设备管理',
  smtDeviceDesc: '管理智能仓储相关设备在线状态与基础信息',
  smtMaterialLib: '商品电子库',
  smtMaterialLibDesc: '以 SKU 为最小单元，记录架位分布、规格与抓取适配状态',
  smtPagePlaceholder: '页面内容建设中',
  warehouseMonitor: '仓储管理',
  productShowcase: '产品展示',
  assistant: '智能助手',
  systemSettings: '系统设置',
  logout: '退出登录',
}
